import React     from 'react';
import PropTypes from 'prop-types';
import { Link }  from 'react-router-dom';

class Back extends React.Component {
    render() {
        return (
            <Link className={ this.props.className } to="/back" onClick={ this.handleLinkClick }
                aria-label={ this.props.backLabel } >
                { this.props.children }
            </Link>
        );
    }

    handleLinkClick = ( e ) => {
        e.preventDefault();

        // if the history is less than 2 then the user got to this page via url,
        // and history.goBack() will leave the site.
        if ( this.context.router.history.length > 2 ) {
            this.context.router.history.goBack();
        } else {
            this.context.router.history.push( '/login' );
        }
    };
}

Back.contextTypes = {
  router: PropTypes.object
};

export default Back;
